<template>
  <v-container fluid>
    <v-alert>{{error.message}}</v-alert>
    <v-card>
      <v-data-table class="elevation-1"
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template v:slot="items" slot-scope="props">
          <td>{{ props.item.identifier}}</td>
          <td><img width=125 v-if="props.item.config.logo" :src="props.item.config.logo"/> {{ props.item.config.brandName}}</td>
          <td>
            <div v-for="name in countryNames(props.item)" :key="name">
              <isrs-flag :country="name" :squared="false"/>
              {{name}}
            </div>
          </td>
          <td>
            <ul>
              <li><router-link :to="`/returnshopportals/${props.item.identifier}`">Settings</router-link></li>
            </ul>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import isoc from 'isoc';
  import {mapGetters} from 'vuex'
  import DataService from '../services/data';
  import IsrsFlag from '../components/IsrsFlag.vue'

  export default {
    components: {IsrsFlag},
    data() {
      return {
        dataService: undefined,
        items: [],
        error: "",
        pagination: {rowsPerPage:10},
        footerProps: {
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageOptions: [10,20,40]
        },        
        loading: true,
        totalItems: 0,
        headers: [
          {text: "Identifier", value: "identifier", sortable: false},
          {text: "Brand", value: "config.brandName", sortable: false},
          {text: "Countries", sortable: false},
          {text: "Actions", sortable: false},
        ]
      };
    },

    watch: {
      pagination() {
        this.queryPagination().then(this.updateDataTable);
      }
    },

    computed: {
      ...mapGetters('config', ['alpha2ToName']),
    },

    mounted() {
      this.dataService = new DataService(this.profile, this.$store.state.tokens)
    },

    methods: {

      getItemPerPage(rows) {
        this.pagination.rowsPerPage = rows;
        this.queryPagination();
      },

      queryPagination() {
        let {sortBy, descending, page, rowsPerPage} = this.pagination;
        
/*         if (descending) {
          sortBy = `${sortBy},desc`;
        }
        if (!sortBy) {
          sortBy = `Id`;
        }
 */
        this.loading = true;
        return this.dataService.getReturnportalParcelnumberContainersByContainerId(this.$route.params.id, page, rowsPerPage, sortBy)
          .then(result => {
            return result
          })
          .then(result => result.data)
          .then(data => {
            this.loading = false
            this.items = data.data
            this.totalItems = data.totalElements;
          })
          .catch(err => {
            this.loading = false
            this.items = []
            this.totalItems = 0;
            console.error('unable to get return-shops by pnc-id', err)
          })
      },

      countryNames(item) {
        return item.countryContactMappings
          .map(c => this.alpha2ToName[c.originCountry])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// GetReturnportalParcelnumberContainers.vue?12fe0126